import Flickity from 'flickity';
import 'flickity-fade';

document.addEventListener('DOMContentLoaded', async () => {
  const IMAGE_PLACEHOLDER_URL = document.querySelector<HTMLElement>('.sticky-buy__image')?.dataset.placeholder || '';

  // Only init HLS.js if there are videos
  const videos = [...document.querySelectorAll('.single-product__gallery-video')] as HTMLVideoElement[];
  if (videos.length) {
    // TODO: Does this dynamic import even work in adonis/prod mode?
    // Or is it no different than importing it at the top of the file?
    const Hls = (await import('hls.js')).default;

    // Init HLS.js
    if (Hls.isSupported()) {
      videos.forEach((video) => {
        const hlsUrl = video.dataset.hlsUrl;
        if (!hlsUrl) {
          return;
        }
        const hls = new Hls();
        hls.on(Hls.Events.MEDIA_ATTACHED, function() {
          console.debug('video and hls.js are now bound together!');
        });
        hls.on(Hls.Events.MANIFEST_PARSED, function(event, data) {
          console.debug('manifest loaded, found ' + data.levels.length + ' quality level');
          console.debug({ event, data });
        });
        hls.loadSource(hlsUrl);
        // bind them together
        hls.attachMedia(video);
      });
    }

    // TODO: Will need to make these auto play/pause when visisible or not.
  }

  /**
   * Play video in current slide (if found) and pause all others
   * @param productGallery Flickity gallery instance
   * @param slideIndex Index of current slide
   */
  const playVideoIfPresent = (productGallery: Flickity, slideIndex: number) => {
    productGallery.cells.forEach((cell, cellIndex) => {
      // Check if cell has video
      let cellVideo = cell.element.querySelector('video');
      if (cellVideo) {
        // If cell is the current slide, play video
        if (cellIndex === slideIndex) {
          cellVideo.play();
        } else {
          // Otherwise, pause it
          cellVideo.pause();
        }
      }
    });
  };

  /**
   * Emit a custom event for product image change (or load),
   * so the sticky buy bar can update itself
   * @param flickity Flickity instance
   * @param index Index of the current slide
   */
  const emitImageChangeEvent = (flickity: Flickity, index: number) => {
    const cellElement = flickity.cells[index].element;
    const imageEl = cellElement.querySelector('img');
    let image = imageEl?.getAttribute('src') || imageEl?.getAttribute('data-src');

    // If no image, check for a video
    if (!image) {
      const videoEl = cellElement.querySelector('video');
      const poster = videoEl?.getAttribute('poster');
      image = poster;
    }

    // If still no image, use placeholder
    if (!image) {
      image = IMAGE_PLACEHOLDER_URL;
    }

    // console.debug({ flickity, index, image });

    // Make a custom event to trigger the sticky buy image update
    // This is listened for in the sticky buy module
    const event = new CustomEvent('product:image-change', {
      detail: {
        index,
        image,
      },
    });
    document.dispatchEvent(event);
  };

  const productGalleryElem = document.querySelector('.js-product-gallery');

  if (productGalleryElem) {
    let productGallery = new Flickity(productGalleryElem, {
      cellSelector: '.js-slide',
      initialIndex: '.js-slide[data-initial]',
      wrapAround: true,
      lazyLoad: 2,
      imagesLoaded: true,
      cellAlign: 'left',
      prevNextButtons: false,
      selectedAttraction: 0.012,
      autoPlay: false,
      fade: true,
      on: {
        ready: function() {
          emitImageChangeEvent(this, this.selectedIndex);
        },
      },
    });

    let thumbs = [...document.querySelectorAll('.js-product-gallery-thumb')];

    thumbs.map((thumb) =>
      thumb.addEventListener('click', (btn) => {
        let index = thumbs.indexOf(btn.target as HTMLButtonElement);
        productGallery.select(index);
      })
    );

    productGallery.on('change', (index: number) => {
      document
        .querySelector('.js-product-gallery-thumb.selected')
        ?.classList.remove('selected');
      thumbs[index].classList.add('selected');

      // Make any videos play/pause when the slide changes
      playVideoIfPresent(productGallery, index);

      emitImageChangeEvent(productGallery, index);
    });

    // Initial play of video if present on first slide
    playVideoIfPresent(productGallery, 0);
  }
});
